__turbopack_context__.v({
  "alignCenter": "align-module-scss-module__SKxk-G__alignCenter",
  "alignJustify": "align-module-scss-module__SKxk-G__alignJustify",
  "alignLeft": "align-module-scss-module__SKxk-G__alignLeft",
  "alignRight": "align-module-scss-module__SKxk-G__alignRight",
  "flex": "align-module-scss-module__SKxk-G__flex",
  "flexCenter": "align-module-scss-module__SKxk-G__flexCenter",
  "flexColumnCenter": "align-module-scss-module__SKxk-G__flexColumnCenter",
  "flexSpaceBetween": "align-module-scss-module__SKxk-G__flexSpaceBetween",
  "flexStart": "align-module-scss-module__SKxk-G__flexStart",
});
